export {SearchResultsConnected as SearchResults} from './SearchResults.connect';
